<template>
  <div
    class="pn pn2"
    style="overflow:hidden"
  >
    <div class="pn-in">
      <div class="c2">
        <div class="pn-hd" style="padding: 0 0 20px 5px;">
          <p class="tit">
            <img
              src="../../assets/images/tit2.png"
              alt=""
            >
          </p>
          <!-- <router-link
            class="more"
            to="/intro"
          >
            更多
          </router-link> -->
          <div class="world-btns">
            <a href="javascript:void(0)" :class="introWorldId===1?'world-btn-red':'world-btn-black'" @click="introTab(1)">一层区</a>
            <a href="javascript:void(0)" :class="introWorldId===2?'world-btn-red':'world-btn-black'" @click="introTab(2)">二层区</a>
            <a href="javascript:void(0)" :class="introWorldId===3?'world-btn-red':'world-btn-black'" @click="introTab(3)">三层区</a>
            <a href="javascript:void(0)" :class="introWorldId===4?'world-btn-red':'world-btn-black'" @click="introTab(4)">血魔区</a>
          </div>
        </div>
        <div class="pn-bd">
          <div class="roles js-tab-slick">
            <!-- <div
              class="bg mr ani"
              id="role"
            >
              <img
                :src="roleImg[infoIndex]"
                alt=""
              >
            </div> -->
            <div class="pagination">
              {{ infoIndex }} / 5
            </div>
            <div class="slick-arrow">
              <!-- <button
                type="button"
                class="slick-prev slick-arrow"
                style="display: block;"
                @click="prevInfo()"
              >
                Previous
              </button><button
                type="button"
                class="slick-next slick-arrow"
                style="display: block;"
                @click="nextInfo()"
              >
                Next
              </button> -->
            </div>
            <div class="tab slider-nav slick-initialized slick-slider">
              <div
                aria-live="polite"
                class="slick-list"
              >
                <div
                  class="slick-track"
                  :style="{'opacity': '1', 'width': '803px', 'transform': 'translate3d(0px, 0px, 0px)'}"
                  role="listbox"
                >
                  <a
                    href="javascript:;"
                    :class="infoIndex===1?'slick-slide slick-cloned current':'slick-slide slick-cloned'"
                    @click="infoIndex = 1"
                    style="width: 80px;"
                    tabindex="-1"
                  >副本地图</a><a
                    href="javascript:;"
                    :class="infoIndex===2?'slick-slide slick-cloned current':'slick-slide slick-cloned'"
                    @click="infoIndex = 2"
                    style="width: 80px;"
                    tabindex="-1"
                  >物品介绍</a><a
                    href="javascript:;"
                    :class="infoIndex===3?'slick-slide slick-cloned current':'slick-slide slick-cloned'"
                    @click="infoIndex = 3"
                    style="width: 80px;"
                    tabindex="-1"
                  >武功介绍</a><a
                    href="javascript:;"
                    :class="infoIndex===4?'slick-slide slick-cloned current':'slick-slide slick-cloned'"
                    @click="infoIndex = 4"
                    style="width: 80px;"
                    tabindex="-1"
                  >装备介绍</a><a
                    href="javascript:;"
                    :class="infoIndex===5?'slick-slide slick-cloned current':'slick-slide slick-cloned'"
                    @click="infoIndex = 5"
                    style="width: 80px;"
                    tabindex="-1"
                  >游戏特色</a>
                </div>
              </div>
            </div>
            <div class="tab-pn slider-for slick-initialized slick-slider">
              <div
                aria-live="polite"
                class="slick-list"
              >
                <div
                  class="slick-track"
                  style="opacity: 1; width: 4500px;"
                  role="listbox"
                >
                  <div
                    class="tab-pn-item mr slick-slide slick-current slick-active"
                    style="width: 500px; position: relative; left: 0px; top: 0px; z-index: 999; opacity: 1;"
                    tabindex="-1"
                    v-if="infoIndex === 1"
                  >
                    <ul
                      class="txt-list"
                    >
                      <li
                        class="item"
                        v-for="(sItem,index) in introList1"
                        :key="index"
                      >
                        <div class="txt">
                          <router-link
                            class="con"
                            :to="{path:'/intro/view',query:{id:sItem.id,tid:infoIndex}}"
                          >
                            副本地图：{{ sItem.title }}
                          </router-link>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div
                    class="tab-pn-item mr slick-slide slick-current slick-active"
                    style="width: 500px; position: relative; left: 0px; top: 0px; z-index: 999; opacity: 1;"
                    tabindex="-1"
                    v-if="infoIndex === 2"
                  >
                    <ul
                      class="txt-list"
                    >
                      <li
                        class="item"
                        v-for="(sItem,index) in introList2"
                        :key="index"
                      >
                        <div class="txt">
                          <router-link
                            class="con"
                            :to="{path:'/intro/view',query:{id:sItem.id,tid:infoIndex}}"
                          >
                            物品介绍：{{ sItem.title }}
                          </router-link>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div
                    class="tab-pn-item mr slick-slide slick-current slick-active"
                    style="width: 500px; position: relative; left: 0px; top: 0px; z-index: 999; opacity: 1;"
                    tabindex="-1"
                    v-if="infoIndex === 3"
                  >
                    <ul
                      class="txt-list"
                    >
                      <li
                        class="item"
                        v-for="(sItem,index) in introList3"
                        :key="index"
                      >
                        <div class="txt">
                          <router-link
                            class="con"
                            :to="{path:'/intro/view',query:{id:sItem.id,tid:infoIndex}}"
                          >
                            武功介绍：{{ sItem.title }}
                          </router-link>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div
                    class="tab-pn-item mr slick-slide slick-current slick-active"
                    style="width: 500px; position: relative; left: 0px; top: 0px; z-index: 999; opacity: 1;"
                    tabindex="-1"
                    v-if="infoIndex === 4"
                  >
                    <ul
                      class="txt-list"
                    >
                      <li
                        class="item"
                        v-for="(sItem,index) in introList4"
                        :key="index"
                      >
                        <div class="txt">
                          <router-link
                            class="con"
                            :to="{path:'/intro/view',query:{id:sItem.id,tid:infoIndex}}"
                          >
                            装备介绍：{{ sItem.title }}
                          </router-link>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div
                    class="tab-pn-item mr slick-slide slick-current slick-active"
                    style="width: 500px; position: relative; left: 0px; top: 0px; z-index: 999; opacity: 1;"
                    tabindex="-1"
                    v-if="infoIndex === 5"
                  >
                    <ul
                      class="txt-list"
                    >
                      <li
                        class="item"
                        v-for="(sItem,index) in introList5"
                        :key="index"
                      >
                        <div class="txt">
                          <router-link
                            class="con"
                            :to="{path:'/intro/view',query:{id:sItem.id,tid:infoIndex}}"
                          >
                            游戏特色：{{ sItem.title }}
                          </router-link>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="c1">
        <div class="pn-hd" style="padding:0px 0px 20px 5px">
          <p class="tit">
            <img
              src="../../assets/images/tit1.png"
              alt=""
            >
          </p>
          <!-- <router-link
            class="more"
            :to="{path:'/strate/list',query:{typeID:0}}"
          >
            更多
          </router-link> -->
          <div class="world-btns">
            <a href="javascript:void(0)" :class="strateWorldId===1?'world-btn-red':'world-btn-black'" @click="strateTab(1)">一层区</a>
            <a href="javascript:void(0)" :class="strateWorldId===2?'world-btn-red':'world-btn-black'" @click="strateTab(2)">二层区</a>
            <a href="javascript:void(0)" :class="strateWorldId===3?'world-btn-red':'world-btn-black'" @click="strateTab(3)">三层区</a>
            <a href="javascript:void(0)" :class="strateWorldId===4?'world-btn-red':'world-btn-black'" @click="strateTab(4)">血魔区</a>
          </div>
        </div>
        <div class="pn-bd js-tab">
          <div class="tab">
            <a
              href="javascript:;"
              :class="gonglueIndex===0?'current':''"
              @click="gonglueIndex=0"
            >江湖攻略</a>
            <!-- <a
              href="javascript:;"
              :class="gonglueIndex===1?'current':''"
              @click="gonglueIndex=1"
            >新手</a>
            <a
              href="javascript:;"
              :class="gonglueIndex===2?'current':''"
              @click="gonglueIndex=2"
            >攻略</a> -->
          </div>
          <div class="tab-pn">
            <div
              class="tab-pn-item"
              v-if="gonglueIndex===0"
            >
              <ul
                class="txt-list"
              >
                <li
                  class="item"
                  v-for="(sItem,index) in sList0"
                  :key="index"
                >
                  <span class="tag">{{ getStrateTypeName(sItem.typeID) }}：</span>
                  <div class="txt">
                    <router-link
                      class="con"
                      :to="{path:'/strate/view',query:{id:sItem.id,tid:gonglueIndex}}"
                    >
                      {{ sItem.title }}
                    </router-link>
                  </div>
                  <span class="date">{{ sItem.createTime | dateformat('MM/DD') }}</span>
                </li>
              </ul>
            </div>
            <!-- <div
              class="tab-pn-item"
              v-if="gonglueIndex===1"
            >
              <ul
                class="txt-list"
              >
                <li
                  class="item"
                  v-for="(sItem,index) in sList1"
                  :key="index"
                >
                  <span class="tag">{{ getStrateTypeName(sItem.typeID) }}：</span>
                  <div class="txt">
                    <router-link
                      class="con"
                      :to="{path:'/strate/view',query:{id:sItem.id,tid:gonglueIndex}}"
                    >
                      {{ sItem.title }}
                    </router-link>
                  </div>
                  <span class="date">{{ sItem.createTime | dateformat('MM/DD') }}</span>
                </li>
              </ul>
            </div> -->
            <!-- <div
              class="tab-pn-item"
              v-if="gonglueIndex===2"
            >
              <ul
                class="txt-list"
              >
                <li
                  class="item"
                  v-for="(sItem,index) in sList2"
                  :key="index"
                >
                  <span class="tag">{{ getStrateTypeName(sItem.typeID) }}：</span>
                  <div class="txt">
                    <router-link
                      class="con"
                      :to="{path:'/strate/view',query:{id:sItem.id,tid:gonglueIndex}}"
                    >
                      {{ sItem.title }}
                    </router-link>
                  </div>
                  <span class="date">{{ sItem.createTime | dateformat('MM/DD') }}</span>
                </li>
              </ul>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import roleImage0 from '../../assets/images/role-mr-type-110e9d9d.png'
import roleImage1 from '../../assets/images/role-wd-type-c1508018.png'
import roleImage2 from '../../assets/images/role1-c1508018.png'
import roleImage3 from '../../assets/images/role2-c1508018.png'
import roleImage4 from '../../assets/images/role-mj-type-c1508018.png'
import { getStrateTypeName } from '../../utils/utils'
export default {
  data () {
    return {
      gonglueIndex: 0,
      infoIndex: 1,
      sList0: [],
      // sList1: [],
      // sList2: [],
      introList1: [],
      introList2: [],
      introList3: [],
      introList4: [],
      introList5: [],
      roleImg: [roleImage0, roleImage1, roleImage2, roleImage3, roleImage4],
      introWorldId: 4,
      strateWorldId: 4
    }
  },
  created () {
    this.getSlist()
    this.getIntroList()
  },
  methods: {
    introTab (worldId) {
      console.log(worldId)
      // this.infoIndex = 1
      this.introWorldId = worldId
      // this.$api.getIntroIndexList(worldId).then(res => {
      //   this.introList1 = res.data.list1
      //   this.introList2 = res.data.list2
      //   this.introList3 = res.data.list3
      //   this.introList4 = res.data.list4
      //   this.introList5 = res.data.list5
      // })
      this.getIntroList()
    },
    getIntroList () {
      this.$api.getIntroIndexList(this.introWorldId).then(res => {
        this.introList1 = res.data.list1
        this.introList2 = res.data.list2
        this.introList3 = res.data.list3
        this.introList4 = res.data.list4
        this.introList5 = res.data.list5
      })
    },
    strateTab (worldId) {
      // this.gonglueIndex = 0
      this.strateWorldId = worldId
      // this.$api.getStrateIndexList(worldId).then(res => {
      //   this.sList0 = res.data.list0
      // })
      this.getSlist()
    },
    getSlist () {
      this.$api.getStrateIndexList(this.strateWorldId).then(res => {
        this.sList0 = res.data.list0
        // this.sList1 = res.data.list1
        // this.sList2 = res.data.list2
      })
    },
    prevInfo () {
      if (this.infoIndex - 1 >= 0) { this.infoIndex-- }
    },
    nextInfo () {
      if (this.infoIndex + 1 < 5) { this.infoIndex++ }
    },
    getStrateTypeName
  }
}
</script>
<style scoped>
.wrapper-index .pn2 .roles #role.mr {
    width: 500px;
    left: 300px;
    /* top: 300px; */
}
.role-desc span{
width:150px;
display:block;
float:left;
margin-right:30px;
line-height:35px;
font-weight: bolder;
}
.role-desc span a{
  color:#999
}
.wrapper-index .pn2 .c2 .role-desc a{
  line-height: 60px;
  font-size: 25px;
}
.wrapper-index .pn2 .c2 .tab{
  padding-right: 0px;
}
.world-btns{
  width:100%;display: block; height: 178px;
}
.world-btn-red{
  width:150px;
  height: 55px;
  float:left;
  margin-top:10px;
  margin-bottom:0px;
  margin-left:40px;
  background: url('../../assets/img/world-bg-red.png');
  background-size:contain ;
  padding-left:25px;
  padding-top: 20px;
  color:#fff;
  font-weight: bolder;
  font-size: 18px;
}
.world-btn-black{
  width:150px;
  height: 55px;
  float:left;
  margin-top:10px;
  margin-bottom:0px;
  margin-left:40px;
  background: url('../../assets/img/world-bg-black.png');
  background-size:contain ;
  padding-left:25px;
  padding-top: 20px;
  color:#fff;
  font-weight: bolder;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/line2.vue